import React from 'react';
import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import TheOffer from '../components/TheOffer';
import HowItWorks from '../components/HowItWorks';
import WhyItWorks from '../components/WhyItWorks';
import FAQ from '../components/FAQ';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import {FiArrowRight, FiShield} from 'react-icons/fi';

const BOOKING_URL = 'https://links.myvoicelocal.com/widget/bookings/10-minute-call-with-stu';

const Home = () => (
  <div className="w-full">
    <Hero />
    <StatsBar />
    <TheOffer />
    <HowItWorks />
    <WhyItWorks />
    <FAQ />
    <section className="py-24 md:py-36 bg-[#faf8f5] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-stone-200 to-transparent" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_50%,rgba(217,119,6,0.05),transparent)]" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-xs font-bold uppercase tracking-widest mb-8">
            Limited Spots Available
          </span>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-8 tracking-tight text-stone-900 font-serif leading-tight">
            Ready to Commit to Your <br />
            <span className="font-light italic text-stone-400">6-Week Transformation?</span>
          </h2>
          <p className="text-xl sm:text-2xl text-stone-500 mb-12 font-light max-w-2xl mx-auto leading-relaxed">
            Spots are strictly limited to maintain our high standard of 1-on-1 coaching. We only work with action-takers.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{scale: 1.03, y: -2}}
              whileTap={{scale: 0.97}}
              className="group flex items-center justify-center gap-3 bg-stone-900 text-white px-10 py-5 rounded-2xl font-bold text-lg shadow-2xl shadow-stone-900/20 hover:bg-amber-700 transition-all"
            >
              Apply For The Challenge Now
              <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
            </motion.a>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-xs font-bold uppercase tracking-widest text-stone-400">
            <span className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-amber-400" />Takes 3 Minutes</span>
            <span className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-amber-400" />100% Secure</span>
            <span className="flex items-center gap-2"><SafeIcon icon={FiShield} className="text-amber-500" />6-Week Results Guarantee</span>
          </div>
        </motion.div>
      </div>
    </section>
  </div>
);

export default Home;